"use client";

import { AnimatePresence, motion } from "motion/react";
import { useProfileEditFooterStore } from "@/features/profile/tutor/store/useProfileEditFooterStore";

export function PersistentFooterActions() {
  const entry = useProfileEditFooterStore((s) => s.entry);

  if (!entry) return null;

  return (
    <div className="bg-background/80 supports-[backdrop-filter]:bg-background/60 absolute inset-x-0 bottom-0 z-30 border-t px-4 py-3 shadow-sm backdrop-blur max-sm:pb-8">
      <AnimatePresence initial={false} mode="wait">
        <motion.div
          key={entry.key}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 4 }}
          initial={{ opacity: 0, y: 4 }}
          transition={{ duration: 0.16, ease: "easeOut" }}
          className="flex w-full items-center"
        >
          {entry.node}
        </motion.div>
      </AnimatePresence>
    </div>
  );
}


